import Lightning from "@lightningjs/sdk/src/Lightning"

export interface CAInfoTemplateSpec extends Lightning.Component.TemplateSpecLoose {
  page: any
}

export default class CAInfo
  extends Lightning.Component<CAInfoTemplateSpec>
  implements Lightning.Component<CAInfoTemplateSpec>
{
  static override _template(): Lightning.Component.Template<CAInfoTemplateSpec> {
    return {
      w: (w) => w,
      h: (h) => h,
      rect: true,
      color: 0x00000000,
      Text: { y: 250, h: 50, w: (w) => w, text: { text: 'About', textColor: 0xffffffff, textAlign: 'center' } },
      DeviceContent: {
        x: 300,
        y: 100+250,
        w: (w) => w,
        h: (h) => (h - 100),
        flex: { direction: 'column', alignItems: 'stretch', justifyContent: 'flex-start' },
      }
    }
  }

  override _getFocused() {
    return this;
  }

  set data(aboutArry: any) {
    aboutArry.map(item => {
      this.tag('DeviceContent').add(
        {
          w: 0,
          h: (item.key == 'UserAgent' ? 150 : 50),
          flexItem: { margin:0  },
          flex: { direction: 'row', alignItems: 'stretch', justifyContent: 'space-between', wrap: true, padding: 20 },
          children: [
            { flexItem: { margin: 0, grow: 1 }, Text: { w: 200, h: (item.key == 'UserAgent' ? 150 : 50), text: { text: item.key, textColor: 0xffffffff, textAlign: 'Left', fontSize: 30 } } },
            { flexItem: { margin: 0, grow: 2 }, Text: { w: 800, h: (item.key == 'UserAgent' ? 150 : 50), text: { text: item.value, textColor: 0xffffffff, textAlign: 'Left', fontSize: 30, wrapText: true } } }
          ],
        }
      )
    })
  }
}
